import styled, { css } from 'styled-components/macro';
import tw from 'tailwind.macro';
import { htmlStyle } from '../../styles';
import { roundShadowBoxStyle } from '../RoundShadowBox';
import Row from '../Row';

const Wrapper = styled.div`
  position: relative;

  ${({ customStyle }) => customStyle}
`;

const RowFlex = styled(Row)`
  ${tw`flex px-def mt-abs6 mb-abs4`};
`;

const Body = styled.div`
  ${tw`w-full md:w-3/4 md:px-def`};
`;

const SectionCol = styled.div`
  ${tw`w-full flex flex-col mb-abs3`};
`;

const HTMLText = styled.div`
  ${htmlStyle}
`;

const TableStyle = css`
  table {
    ${tw`w-full block`};
    border-collapse: collapse;
    ${roundShadowBoxStyle}
    ${tw`overflow-x-auto mb-abs4`};
  }

  tbody {
    tr {
      td:nth-child(odd) {
        ${tw`bg-white`}
      }
    }

    tr:last-child {
      border-bottom: none;
    }
  }

  th {
    ${tw`whitespace-no-wrap p-abs1 px-abs1 md:px-abs4 bg-primary400 text-grey200`}
  }

  td {
    ${tw`text-center bg-grey100 w-full`};
    padding: 1.5rem;
  }
`;

export { Breadcrumb } from './Breadcrumb';
export { CustomH2 } from './CustomH2';
export { CustomH3 } from './CustomH3';
export { Body, HTMLText, RowFlex, SectionCol, TableStyle, Wrapper };
